
import React, { Component } from "react";
import { notification, message, Spin } from 'antd';
import { Legend, PieChart, Pie, Cell, Tooltip } from 'recharts';
 
const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const style = {
  top: '83%',
  right: 0,
  transform: 'translate(0, -50%)',
  lineHeight: '2px',
};

  

export default class BasicBars extends Component {

  state = {
    consultasxGenero:[],
    totalConsultas: null,
    id_interval: null,
    loading:false
  }

  componentDidMount() {

      const { unidad_medica_user, periodo, backend } = this.props;

      fetch(`${backend}/totalconsultasxgenero/unidad/${unidad_medica_user}/periodo/${periodo}`,
      {
          method: "GET",
          headers: {
              'Access-Control-Allow-Origin': '*'
          }
      }).then((res) => {
          return res.json();
      }).then((data) => {
          this.setState({
            consultasxGenero: data.data,
            totalConsultas: data.total,
            // id_interval: id_interval
            loading:true
          })
      }).catch((error) => {
          console.log(error);
          notification.error({
              message: 'Error',
              description: "Ocurrió un error al obtener consultas por género.",
          });
          message.destroy()
      });

    // }, 3000);
  }

  // componentWillUnmount() {
  //   //aqui matamos el setinterval para no envasurar nuestro dom
  //   clearInterval(this.state.id_interval);
  // }

  render() {
    const { consultasxGenero, loading } = this.state;
    
    // const showComponent  = 

    

    return (
      loading ? <PieChart 
                  width={450} height={450}  
                  className="hsc-piechart-cons-gen"
                >
                  <Pie
                    className="hsc-pie-cons-gen" 
                    data={consultasxGenero}
                    cx={230}
                    cy={220}
                    labelLine={false}
                    label={renderCustomizedLabel}
                    outerRadius={200}
                    fill="#8884d8"
                    dataKey="value"
                  >
                    {consultasxGenero.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Legend iconSize={5} 
                    wrapperStyle={style}
                  />
                  <Tooltip />
                </PieChart>
                : <Spin size="small" />
      );
  }
}